import { HttpService } from 'src/app/services/http-wrapper.service';
import { ErrorMessageComponent } from 'src/app/shared/error-message/error-message.component';
import { Component, OnInit, ViewChild } from '@angular/core';


@Component({
  selector: 'app-view-submissions',
  templateUrl: './view-submissions.component.html',
  styleUrls: ['./view-submissions.component.css']
})
export class ViewSubmissionsComponent implements OnInit {
  @ViewChild(ErrorMessageComponent)

  public errorComponent!: ErrorMessageComponent;
  submissionsData:any;
  query!: string;
  constructor(public httpService : HttpService,) { }


  
  ngOnInit(): void {
    this.httpService.startCallGroup(1,"View Submissions");
      this.loadConfiguration();

  }
  loadConfiguration() {
    this.httpService.get("assets/submissions.json", this.errorComponent)
      .subscribe((dummyData) => {
        this.submissionsData = dummyData;
      });
  }
}
